<template>
  <div class="label">
    <div class="lable_column" v-for="(menu, index) in keywords" :key="index">
      <div class="title">{{ menu.name }}：</div>
      <ul>
        <li
          v-for="(item, idx) in menu.menuList"
          :key="idx"
          :class="{ select: item.isActive }"
          @click="categorySearchItemClick(menu.name, item)"
        >{{ item.name }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategorySearchCom',
  props: {
    categorySearchData: Array
  },
  data() {
    return {
      keywords: []
    }
  },
  watch: {
    categorySearchData() {
      this.keywords = this.categorySearchData
    }
  },
  methods: {
    categorySearchItemClick(name, item) {
      let isClear = name === '关键字' && item.name === '全部'
      this.keywords.forEach(menu => {
        if (menu.name === name) {
          menu.menuList.forEach(m => {
            m.isActive = m.searchField === item.searchField ? !m.isActive : false
          })
        }
      })
      const filterParams = {}
      let keywordParams
      this.keywords.forEach(menu => {
        if (menu.name !== '关键字') {
          menu.menuList.forEach(m => {
            if (m.isActive && typeof m.searchField === 'string') {
              try {
                Object.assign(filterParams, JSON.parse(m.searchField))
              } catch (e) {}
            }
          })
        } else {
          menu.menuList.forEach(m => {
            if (m.isActive && typeof m.searchField === 'string') {
              keywordParams = JSON.parse(m.searchField)
            }
          })
        }
      })
      this.keywords = [...this.keywords]
      this.$emit('categorySearchItemClick', filterParams, keywordParams, isClear)
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  width: 1196px;
  margin: 614px auto 49px;

  .lable_column {
    font-family: PingFang;
    font-weight: 700;
    font-size: 14px;
    color: #000;
    display: flex;
    align-items: flex-start;

    .title {
      width: 64px;
      flex-shrink: 0;
    }

    ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      cursor: pointer;
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-right: 22px;
        margin-bottom: 20px;
        font-weight: 400;

        &.select {
          color: #772b92;
        }
      }
    }
  }
}
</style>
